export default __webpack_public_path__ + "static/media/weightlossregime_4@2x.338c623b.jpg";